import { moment } from '@eventbrite/date';
import reduce from 'lodash/reduce';
import {
    CUSTOM_DATE,
    EVENTBRITE_CATEGORY_TO_REFINEMENT,
    EVENTBRITE_FORMAT_TO_REFINEMENT,
} from '../../constants';
import {
    FILTER_TYPE_GA_MAP,
    GA_SEARCH_CATEGORY,
} from '../../constants/analytics';
import { trackEventClickInternal } from '../api/analytics';

/* Internal Tracking */
export const trackInternalAppClick = (trackingData: object) => {
    const defaultData = {
        platform: 'web',
        timestamp: parseInt(moment().format('X'), 10),
        selectionType: 'event',
    };

    trackEventClickInternal({ ...defaultData, ...trackingData });
};

/*
 * @param selectedFilter -- object -- ${filterType}: ${filterValue}
 *      - Filter object passed to search API upon selection
 * @param customDate -- object -- {startDate: 'string', endDate: 'string'}
 *      - Optional param that exists when filterValue === CUSTOM_DATE
 * @param category -- string
 *      - Future proof support for if filters need to be associated to category other than search
 *
 * Function takes in filter selection information and creates the necessary anayltics tracking
 * body from it for GA tracking
 */
export const getFilterEventTrackingData = (
    selectedFilter?: object,
    customDate?: { startDate?: string; endDate?: string },
    category: string = GA_SEARCH_CATEGORY,
) =>
    reduce(
        selectedFilter,
        (memo: any, filterValue: string, filterType: string) => {
            if (filterValue || filterValue === '') {
                if (filterType in FILTER_TYPE_GA_MAP) {
                    let label = filterValue;
                    const filterAnalyticsAction =
                        FILTER_TYPE_GA_MAP[filterType];

                    //Special case for customDate
                    if (filterValue === CUSTOM_DATE) {
                        const { startDate, endDate } = customDate || {};

                        label = `${startDate}--${endDate}`;
                    }

                    //Special case for category
                    if (EVENTBRITE_CATEGORY_TO_REFINEMENT[filterValue]) {
                        label = EVENTBRITE_CATEGORY_TO_REFINEMENT[filterValue];
                    }

                    //Special case for format
                    if (EVENTBRITE_FORMAT_TO_REFINEMENT[filterValue]) {
                        label = EVENTBRITE_FORMAT_TO_REFINEMENT[filterValue];
                    }

                    return [
                        ...memo,
                        {
                            category,
                            label,
                            action: filterAnalyticsAction,
                        },
                    ];
                }
            }

            return memo;
        },
        [],
    );
